/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:16
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-09 16:43:30
 */
import Konva from "konva"
import { createFromJSON } from "./help.js"
import { GraphElement } from "../graph-element.js"


class PCCElement extends GraphElement {
  constructor(topology, x, y) {
    super(topology, 'pcc', x, y, {
      text: '电表',
      port: true,
      width: 32,
      height: 36,
    })
    
    // 电表类型: 关口电表:1, 并网电表:3, 负载电表:4, 光伏电表:5
    this.meterType = 1

    this.onLoad(() => {

      this.prop_y = 0
      this.prop_x = 50

      this.addProperty('功率', 'kW')
      this.addProperty('无功功率', 'kvar')
      this.addProperty('电流', 'A')
      this.addProperty('电压', 'V')


      // this._addFlashMask()
    })

    this.onRemove(() => {
      log('remove pcc')
      // this._stopFlashAnimate()
    })
  }

  updateData(data) {
    this.updateProperty('功率', data.p_total)
    this.updateProperty('无功功率', data.q_total)
    this.updateProperty('电流', data.i_a)
    this.updateProperty('电压', data.u_a)
  }

  // 设置电表类型: 关口电表:1, 并网电表:3, 负载电表:4, 光伏电表:5
  setMeterType(type) {
    this.meterType = Number(type)
  }

  toJSON() {
    return {
      ...super.toJSON(),
      meterType: this.meterType,
    }
  }

  static fromJSON(topology, node, complete) {
    return createFromJSON(this)(topology, node, complete).then((elem) => {
      if (node.meterType != null) {
        elem.meterType = Number(node.meterType)
      }
      return elem
    })
  }

  addToLayer(layer) {
    super.addToLayer(layer)
    // if (!this.animRunning) {
    //   this._runFlashAnimate()
    // }
  }

  _addFlashMask() {
    this.flashMask = new Konva.Rect({
      x: 20,
      y: 30,
      width: 30,
      height: 30,
      // fill: '#ccc',
      visible: false,
      fillLinearGradientStartPoint: { x: 15, y: 0 },
      fillLinearGradientEndPoint: { x: 15, y: 30 },
      fillLinearGradientColorStops: [0, '#5BDF35', 1, '#3FBB4D'],
    })
    this.g.add(this.flashMask)
  }

  _runFlashAnimate() {
    this.animRunning = true
    let val = 0
    this._t = setInterval(() => {
      // console.log('val', val)
      val ? this.flashMask.hide() : this.flashMask.show()
      val++
      if (val >= 8) {
        val = 0
      }
    }, 300)
  }

  _stopFlashAnimate() {
    this.animRunning = false
    clearInterval(this._t)
  }
}


export { PCCElement }
